import { dispatch } from "../store/store";
import {
  saveTreatmentPlanDraft as saveDraftAction,
  getTreatmentPlanDraft as getDraftAction,
  clearTreatmentPlanDraft as clearDraftAction,
  clearAllTreatmentPlanDrafts as clearAllDraftsAction,
  setActiveConsultationId as setActivConsultationAction,
  resetUpdateTreatmentPlanState as resetUpdateAction,
  UpdateTreatmentPlanData,
  getPatientActiveTreatmentPlanData,
  deleteTreatmentPlanActionData,
  completeConsultationHistoryData,
  setLinkTreatmentPlanDialogOpen as setLinkDialogAction,
  setLinkedTreatmentPlanId as setLinkedPlanIdAction,
  clearLinkedTreatmentPlanId as clearLinkedPlanIdAction,
  generateAITreatmentPlanData,
  linkAppointmentConsultationData,
  updateTreatmentPlanFollowUpStatusData,
  addConsultationLinkedTemplateData,
} from "../features/treatmentPlanSlice/treatmentPlanSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "treatmentPlan";

export const setLinkTreatmentPlanDialog = (isOpen) => {
  dispatch(setLinkDialogAction(isOpen));
};

export const resetUpdateTreatmentPlanState = () => {
  dispatch(resetUpdateAction());
};

export const saveTreatmentPlanDraft = (consultationId, draftData) => {
  try {
    dispatch(saveDraftAction({ consultationId, draftData }));
  } catch (error) {
    console.error(`[TreatmentPlan Dispatcher] Error saving draft:`, error);
  }
};

export const getTreatmentPlanDraft = (consultationId) => {
  try {
    const state = dispatch(getDraftAction({ consultationId }));
    return state;
  } catch (error) {
    console.error(`[TreatmentPlan Dispatcher] Error getting draft:`, error);
    return null;
  }
};

export const clearTreatmentPlanDraft = (consultationId) => {
  try {
    dispatch(clearDraftAction({ consultationId }));
  } catch (error) {
    console.error(`[TreatmentPlan Dispatcher] Error clearing draft:`, error);
  }
};

export const clearAllTreatmentPlanDrafts = () => {
  try {
    dispatch(clearAllDraftsAction());
  } catch (error) {
    console.error(
      `[TreatmentPlan Dispatcher] Error clearing all drafts:`,
      error,
    );
  }
};

export const setActiveTreatmentPlanConsultation = (consultationId) => {
  try {
    dispatch(setActivConsultationAction(consultationId));
  } catch (error) {
    console.error(
      `[TreatmentPlan Dispatcher] Error setting active consultation:`,
      error,
    );
  }
};

export const updateTreatmentPlan = async (data) => {
  let result = null;
  try {
    result = await dispatch(UpdateTreatmentPlanData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const getPatientActiveTreatmentPlan = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientActiveTreatmentPlanData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const deleteTreatmentPlanAction = async (
  treatmentPlanId,
  consultationId,
  patientId,
  actionId,
) => {
  let result = null;
  const payload = {
    TreatmentPlanId: treatmentPlanId,
    ConsultationId: consultationId,
    PatientId: patientId,
  };
  if (actionId) {
    payload.ActionID = actionId;
  }
  try {
    result = await dispatch(deleteTreatmentPlanActionData(payload)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, payload);
    throw error;
  }
  return result;
};

export const completeConsultationHistory = async (consultationId) => {
  let result = null;
  const payload = {
    consultationId,
  };
  try {
    result = await dispatch(completeConsultationHistoryData(payload)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, payload);
    throw error;
  }
  return result;
};

export const setLinkedTreatmentPlan = (planId, appointmentId = null) => {
  try {
    dispatch(
      setLinkedPlanIdAction({
        planId,
        appointmentId,
      }),
    );
  } catch (error) {
    console.error(
      `[TreatmentPlan Dispatcher] Error setting linked treatment plan:`,
      error,
    );
  }
};

export const clearLinkedTreatmentPlan = () => {
  try {
    dispatch(clearLinkedPlanIdAction());
  } catch (error) {
    console.error(
      `[TreatmentPlan Dispatcher] Error clearing linked treatment plan:`,
      error,
    );
  }
};

export const generateAITreatmentPlan = async (data) => {
  let result = null;
  try {
    result = await dispatch(generateAITreatmentPlanData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const linkAppointmentConsultation = async (data) => {
  let result = null;
  try {
    result = await dispatch(linkAppointmentConsultationData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const updateTreatmentPlanFollowUpStatus = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      updateTreatmentPlanFollowUpStatusData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const addConsultationLinkedTemplate = async (data) => {
  let result = null;
  try {
    result = await dispatch(addConsultationLinkedTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    console.warn("[ConsultationLinkedTemplate] Failed to save:", error);
  }
  return result;
};
